import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  DialogActions,
  Typography,
} from "@mui/material";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  whiteSpace: "nowrap",
};

const DeleteUser = ({ theme, deleteProfile }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal((prev) => !prev);
  };

  const handleConfirm = async () => {
    await deleteProfile();
    handleModal();
  };

  return (
    <>
      <Button
        onClick={handleModal}
        variant="outlined"
        color="error"
        theme={theme}
        fullWidth
        sx={buttonSx}
      >
        Delete
      </Button>
      <Dialog open={openModal} onClose={handleModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Delete profile</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              Are you sure you want to delete your profile? This action is permanent
              and cannot be undone.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleModal} color="inherit" sx={buttonSx} theme={theme}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="error"
            theme={theme}
            sx={buttonSx}
          >
            Delete profile
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteUser;
